(function($) {

  'use strict';

  function Header() {

    var self = this,
        $cache = {},
        baseFontSize = 62.5,
        ratioFontSize = 0.4,
        currentDkNav = false,
        dkIsOpen = false,
        mbIsOpen = false,
        options = {
          example: null,
        };

    function closeSubNavTl(target) {
      var $sub = $cache.fixedNavDkSubs.filter('[data-parent="'+target+'"]');
      if($sub.length == 0) return false;

      var tl = new TimelineMax({onComplete: function() {
        $sub.removeClass('is-current');
      }});

      tl.to($sub, 0.5, {opacity: 0, ease: Expo.easeOut}, 0);
      tl.to($sub, 0.6, {y: -400, force3D: true, ease: Power2.easeOut}, 0);

      return tl;
    }

    function openSubNavTl(target) {
      var $sub = $cache.fixedNavDkSubs.filter('[data-parent="'+target+'"]');
      if($sub.length == 0) return false;

      var tl = new TimelineMax();
      tl.add(function(){
        currentDkNav = target;
        $sub.addClass('is-current');
      });
      tl.fromTo($sub, 0.8, {opacity: 0}, {opacity: 1, ease: Quad.easeInOut}, 0.10);
      tl.fromTo($sub, 0.7, {y: 400}, {y: 0, force3D: true, ease: Power2.easeOut}, 0);

      return tl;
    }

    function closeNavDk() {
      if(!dkIsOpen) return false;

      var tl = new TimelineMax({paused: true, onComplete: function() {
        $cache.html.removeClass('scroll-disabled');
        $cache.fixedNavDk.removeClass('is-open');
        $cache.fixedNavDkSubs.removeClass('is-current');
        $cache.navPrimaryDkCtas.removeClass('is-active');
        dkIsOpen = false;
      }});

      tl.to($cache.fixedNavDkContent, 0.5, {y: "-100%", force3D: true, ease: Cubic.easeOut}, 0);
      tl.to($cache.fixedNavDkBg, 0.4, {opacity: 0, clearProps: 'all', ease: Quad.easeInOut}, 0.1);
      tl.to($cache.fixedNavDkClose, 0.5, {opacity: 0, ease: Cubic.easeOut}, 0);

      tl.play();
    }

    function openNavDk(target) {
      if(dkIsOpen) return false;
      dkIsOpen = true;

      var tl = new TimelineMax({paused: true});
      tl.add(function(){
        $cache.html.addClass('scroll-disabled');
        $cache.fixedNavDk.addClass('is-open');
      }, 0);

      tl.from($cache.fixedNavDkBg, 0.8, {opacity: 0}, {ease: Power2.easeIn}, 0);
      tl.fromTo($cache.fixedNavDkContent, 0.7, {y: "-100%"}, {y: "0%", force3D: true, ease: Power3.easeOut}, 0.1);

      tl.fromTo($cache.fixedNavDkClose, 0.5, {opacity: 0}, {opacity: 1, ease: Expo.easeOut}, 0.35);
      tl.fromTo($cache.fixedNavDkClose, 0.6, {scale: 0.4}, {scale: 1, force3D: true, ease: Back.easeOut}, 0.35);

      if(target !== undefined) {
        var tlContent = openSubNavTl(target);
        if(tlContent) tl.add(tlContent, 0.1);
      }

      tl.play();
    }

    function toggleSubDk(oldTarget, newTarget) {
      var tl = new TimelineMax({paused: true});

      var tlClose = closeSubNavTl(oldTarget);
      var tlOpen = openSubNavTl(newTarget);

      if(tlClose) tl.add(tlClose, 0);
      if(tlOpen) tl.add(tlOpen, 0.3);

      tl.play();
    }

    /**
     * Toggle Nav Dk
     */
    function toggleNavDk(e) {
      e.preventDefault();

      var $el = $(this);
      var target = $el.data('target');

      $cache.navPrimaryDkCtas.removeClass('is-active');
      $el.addClass('is-active');

      if(dkIsOpen) {
        if(currentDkNav == target) {
          closeNavDk();
        } else {
          toggleSubDk(currentDkNav, target);
        }
      } else {
        openNavDk(target);
      }
    }

    function closeSubMb(e) {
      e.preventDefault();

      var $el = $(this);
      var $sub = $el.closest('.mb-nav-content');
      var $subContent = $sub.find('.mb-nav-main-content');

      var tl = new TimelineMax({paused: true, onComplete: function() {
        $sub.removeClass('is-current');
      }});

      tl.to($sub, 0.5, {x: "100%", force3D: true, ease: Cubic.easeOut}, 0.1);
      tl.to($subContent, 0.5, {opacity: 0, ease: Expo.easeOut}, 0);

      tl.play();
    }

    function openSubMb(e) {
      e.preventDefault();

      var $el = $(this);
      var target = $el.data('target');
      var $sub = $cache.fixedNavMbSubs.filter('[data-parent="'+target+'"]');
      var $subContent = $sub.find('.mb-nav-main-content');

      var tl = new TimelineMax({paused: true});
      tl.add(function(){
        $sub.addClass('is-current');
      }, 0);

      tl.fromTo($sub, 0.7, {x: "100%"}, {x: "0%", force3D: true, ease: Power3.easeOut}, 0);
      tl.fromTo($subContent, 0.7, {opacity: 0}, {opacity: 1, ease: Quad.easeInOut}, 0.3);
      tl.fromTo($subContent, 0.6, {x: 200}, {x: 0, force3D: true, ease: Power2.easeOut}, 0.2);

      tl.play();
    }

    function closeNavMb() {
      if(!mbIsOpen) return false;

      var tl = new TimelineMax({paused: true, onComplete: function() {
        $cache.html.removeClass('scroll-disabled');
        $cache.fixedNavMb.removeClass('is-open');
        $cache.fixedNavMbSubs.removeClass('is-current');
        mbIsOpen = false;
      }});

      tl.add(function(){
        $cache.burger.removeClass('is-cross');
      }, 0);

      tl.to($cache.fixedNavMbContainer, 0.5, {x: "100%", force3D: true, ease: Cubic.easeOut}, 0.1);
      tl.to($cache.fixedNavMbContent, 0.5, {opacity: 0, ease: Expo.easeOut}, 0);

      tl.play();
    }

    function openNavMb() {
      if(mbIsOpen) return false;
      mbIsOpen = true;

      var tl = new TimelineMax({paused: true});
      tl.add(function(){
        $cache.html.addClass('scroll-disabled');
        $cache.burger.addClass('is-cross');
        $cache.fixedNavMb.addClass('is-open');
      }, 0);

      tl.fromTo($cache.fixedNavMbContainer, 0.7, {x: "100%"}, {x: "0%", force3D: true, ease: Power3.easeOut}, 0);
      tl.fromTo($cache.fixedNavMbContent, 0.7, {opacity: 0}, {opacity: 1, ease: Quad.easeInOut}, 0.3);
      tl.fromTo($cache.fixedNavMbContent, 0.6, {x: 200}, {x: 0, force3D: true, ease: Power2.easeOut}, 0.2);

      tl.play();
    }

    /**
     * Toggle Nav Mb
     */
    function toggleNavMb(e) {
      e.preventDefault();

      if(mbIsOpen) {
        closeNavMb();
      } else {
        openNavMb();
      }
    }

    /**
     * Range change event
     */
    function onRangeChange() {
      var $input = $(this);
      var val = $input.val();

      if($cache.rangeDk[0] == $input[0]) {
        $cache.rangeMb.val(val);
      } else {
        $cache.rangeDk.val(val);
      }

      if(val == 0) {
        //Reset
        $cache.html.removeAttr('style');

        sessionStorage.fontSize = false;
        sessionStorage.fontSizeVal = false;
        sessionStorage.removeItem('fontSizeVal');
        sessionStorage.removeItem('fontSize');
      } else {
        var percent = (val/100)*ratioFontSize;
        var multiplier = 1+percent;
        var fontsize = baseFontSize*multiplier;

        $cache.html.css('font-size', fontsize+"%");

        sessionStorage.setItem('fontSizeVal', val);
        sessionStorage.setItem('fontSize', fontsize);
      }

      window.cache.$window.trigger('resize');
    }

    /**
     * Set header pos
     */
    function setHeaderPos() {
      var height = $cache.header.height();

      $cache.main.css('padding-top', height);
      $cache.fixedNavDkContainer.css('padding-top', height);
      $cache.fixedNavMbContainer.css('padding-top', height);
    }

    /**
     * Generic resize
     */
    function onResize() {

      setHeaderPos();

      //Toggle Mobile/Desktop
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if ((window.bp.getValue() === 'xl' || window.bp.getValue() === 'lg') && (window.bp.getLastValue() === 'md' || window.bp.getLastValue() === 'sm' || window.bp.getLastValue() === 'xs'|| window.bp.getLastValue() === null)) {
          //Desktop
          if(mbIsOpen) {
            closeNavMb();
          }
        }

        if ((window.bp.getValue() === 'sm' || window.bp.getValue() === 'xs' || window.bp.getValue() === 'md') && (window.bp.getLastValue() === 'xl' || window.bp.getLastValue() === 'lg' || window.bp.getLastValue() === 'md' || window.bp.getLastValue() === null)) {
          //Mobile
          if(dkIsOpen) {
            closeNavDk();
          }
        }
      }
    }

    /**
     * Init Cache
     */
    function initCache() {
      $cache.html = $('html');
      $cache.body = $cache.html.find('body');
      $cache.main = $cache.body.find('.main');

      $cache.headerTop = $cache.header.find('.header-top');
      $cache.headerBottom = $cache.header.find('.header-bottom');

      $cache.burger = $cache.headerBottom.find('.burger-nav-wrap');

      $cache.navPrimaryDk = $cache.headerBottom.find('.nav-primary');
      $cache.navPrimaryDkCtas = $cache.navPrimaryDk.find('a');

      $cache.fixedNavDk = $cache.body.find('.fixed-dk-nav');
      $cache.fixedNavDkBg = $cache.fixedNavDk.find('.fixed-dk-nav-background');
      $cache.fixedNavDkContainer = $cache.fixedNavDk.find('.fixed-dk-nav-container');
      $cache.fixedNavDkContent = $cache.fixedNavDkContainer.find('.container-inner');
      $cache.fixedNavDkClose = $cache.fixedNavDkContainer.find('.close-cta');

      $cache.fixedNavDkSubs = $cache.fixedNavDkContent.find('.sub-menu-wrap');

      $cache.fixedNavMb = $cache.body.find('.fixed-mb-nav');
      $cache.fixedNavMbContainer = $cache.fixedNavMb.find('.fixed-mb-nav-container');
      $cache.fixedNavMbContent = $cache.fixedNavMbContainer.find('.container-inner');

      $cache.fixedNavMbMain = $cache.fixedNavMbContent.find('.mb-nav-main');
      $cache.navPrimaryMb = $cache.fixedNavMbMain.find('.nav-primary');
      $cache.navPrimaryMbCtas = $cache.navPrimaryMb.find('a');

      $cache.fixedNavMbSubs = $cache.fixedNavMbContent.find('.mb-nav-content');
      $cache.fixedNavMbSubsBack = $cache.fixedNavMbSubs.find('.back-nav');

      $cache.rangeDk = $cache.headerTop.find('.range input');
      $cache.rangeMb = $cache.fixedNavMbMain.find('.range input');
    }

    /**
     * Register Events
     */
    function registerEvents() {
      window.cache.$window.on('resize', onResize);

      $cache.navPrimaryDkCtas.on('click', toggleNavDk);

      $cache.fixedNavDkClose.on('click', closeNavDk);

      $cache.burger.on('click', toggleNavMb);
      $cache.burger.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.burger.trigger('click');
        }
      });

      $cache.navPrimaryMbCtas.on('click', openSubMb);
      $cache.fixedNavMbSubsBack.on('click', closeSubMb);

      $cache.rangeDk.on('input', onRangeChange);
      $cache.rangeMb.on('input', onRangeChange);
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      $cache.header = options.$el;
      initCache();

      //Font-size on load
      if(sessionStorage.getItem('fontSizeVal') && sessionStorage.getItem('fontSize')) {
        $cache.rangeMb.val(sessionStorage.getItem('fontSizeVal'));
        $cache.rangeDk.val(sessionStorage.getItem('fontSizeVal'));
        $cache.html.css('font-size', sessionStorage.getItem('fontSize')+"%");
      }

      registerEvents();

      // *************
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Header = Header;

}(jQuery));
